import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PreventLeadingSpaceService {

  constructor(@Inject(DOCUMENT) private readonly document: Document) { }

  initialize() {
    const inputElements = this.document.querySelectorAll('input, textarea');
    inputElements.forEach((inputElement) => {
      inputElement.addEventListener('input', this.preventLeadingSpace);
    });
  }

  private readonly preventLeadingSpace = (event: Event): void => {
    const inputElement = event.target as HTMLInputElement | HTMLTextAreaElement;
    if (inputElement.value.trimStart() !== inputElement.value) {
      inputElement.value = inputElement.value.trimStart();
    }
  }

}
